<template>
  <Section id="explore-section" class="explore">
    <div class="componata-container">
      <div class="grid-2_xs-1-equalHeight">
        <div class="col">
          <router-link :to="cLink('/fertige')" class="explore__banner explore__fertigen">
            <div class="explore__header">
              <h3 class="explore__title">Fertige Präsente</h3>
              <p class="explore__subtitle">Thematisch perfekt abgestimmt.</p>
            </div>

            <p class="explore__description">Unsere Präsentboxen beinhalten ausschließlich ausgewählte Delikatessen aus aller Welt. Hochwertige und exklusive Feinkost für ganz besondere Menschen.</p>

            <Button class="explore__btn">Alle Präsente anzeigen <i class="icon icon-angle-right"></i></Button>

            <img
              :srcset="`
                ${require('@/assets/images/promo-fertigen@2x.png')}?format=${webPFormat('png')}&width=1126&nearlossless=1&quality=80 1126w,
                ${require('@/assets/images/promo-fertigen@2x.png')}?format=${webPFormat('png')}&width=563&nearlossless=1&quality=80 563w
              `"
              sizes="
                (max-width: 36em) 100vw,
                34em
              "
              :src="`${require('@/assets/images/promo-fertigen@2x.png')}?format=${webPFormat('png')}&width=563&nearlossless=1&quality=80`"
              alt="Fertigen Präsente Beispiel"
              class="explore__pic"
              loading="lazy"
            >
          </router-link>
        </div>

        <div class="col">
          <router-link :to="cLink('/zusammenstellen')" class="explore__banner explore__individuelles">
            <div class="explore__header">
              <h3 class="explore__title">Selbst zusammenstellen</h3>
              <p class="explore__subtitle">Sie bestimmen jede Delikatesse.</p>
            </div>

            <p class="explore__description">Persönlicher geht es kaum: Legen Sie jede Delikatesse selbst fest. Wir erstellen Ihre individuelle Präsentbox komplett nach Ihren Wünschen!</p>

            <Button class="explore__btn">Präsente zusammenstellen <i class="icon icon-angle-right"></i></Button>

            <img
              :srcset="`
                ${require('@/assets/images/promo-individuelles@2x.png')}?format=${webPFormat('png')}&width=1126&nearlossless=1&quality=80 1126w,
                ${require('@/assets/images/promo-individuelles@2x.png')}?format=${webPFormat('png')}&width=563&nearlossless=1&quality=80 563w
              `"
              sizes="
                (max-width: 36em) 100vw,
                34em
              "
              :src="`${require('@/assets/images/promo-individuelles@2x.png')}?format=${webPFormat('png')}&width=563&nearlossless=1&quality=80`"
              alt="Fertigen Präsente Beispiel"
              class="explore__pic"
              loading="lazy"
            >
          </router-link>
        </div>
      </div>
    </div>
  </Section>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Section from '@/components/PresentPage/Section';
import Button from '@/components/Common/Button';

export default {
  name: 'Explore',
  mixins: [logicMixin, helperMixin],
  components: {
    Section,
    Button
  },
  created () {
    this.trackEvent('exploreSectionShown');
  }
};
</script>

<style lang="scss" scoped>
/**
 * Explore
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Explore other presents and Componata's options
 * @since 2022-04-04
**/

$component: 'explore';

.#{$component} {
  z-index: 0;
  background-color: $white;

  &__banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 map-get($spacers, 6);
    border-radius: $border-radius;
    text-align: center;
    color: $ink;
    transition: background-color linear 0.2s;
    will-change: transform;
  }

  &__header {
    @include margin-top(map-get($spacers, 4) * 2);
    @include margin-bottom(map-get($spacers, 5));
    text-shadow: 0 1px 0 $white;
  }

  &__title {
    margin: 0;
    @include font-size(map-get($landing-page, 'font-size-title'));
    font-weight: $font-weight-bolder;
  }

  &__subtitle {
    margin: 0;
    color: $ink-light;
    @include font-size($font-size-xl);
    line-height: 170%;
    font-weight: $font-weight-light;
  }

  &__description {
    @include margin-bottom(map-get($spacers, 4));
    @include font-size($font-size-lg);
    font-weight: $font-weight-light;
    text-shadow: 0 1px 0 $white;
  }

  &__btn {
    transition: all ease-in-out 0.1s;
  }

  &__pic {
    display: block;
    width: calc(100% + #{map-get($spacers, 6) * 2});
    // width: 100%;
    @include margin-top(map-get($spacers, 5));
    margin-left: map-get($spacers, 6);
    margin-right: map-get($spacers, 6);
    @include imageRendering;
  }

  // Variants
  &__fertigen {
    background-color: #f6fdff;
    background-image: url('~@/assets/images/promo-fertigen-bgr.svg');
    background-position: center bottom no-repeat;
    background-size: cover;

    @include hover () {
      background-color: #e3f7fe;
    }
  }

  &__individuelles {
    background-color: #FFF6F6;
    background-image: linear-gradient(160deg, #FFF7F7 30%, #FFEBFB 93%);

    @include hover () {
      background-color: #f3f7ff;
      background-image: linear-gradient(160deg, #fff1f6 30%, #FFEBFB 93%);
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__banner {
      padding: 0 map-get($spacers, 4);
    }

    &__pic {
      width: calc(100% + #{map-get($spacers, 4) * 2});
      margin-left: map-get($spacers, 4);
      margin-right: map-get($spacers, 4);
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
